export default __webpack_public_path__ + "static/media/Believer's Helm of the Purple Sun.073ef415.jpg";